<template>
  <div class="contract">
    <mt-header title="添加联系人" class="reftitle">
      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>
      <mt-button @click="saveContact" slot="right">保存</mt-button>
    </mt-header>
    <div class="savesigner">
      <mt-field label="联系人姓名" placeholder="请输入联系人姓名" v-model="name"></mt-field>
      <mt-field label="联系人手机号" placeholder="请输入联系人手机号" v-model="mobile"></mt-field>
      <mt-field label="联系人邮箱" placeholder="请输入联系人邮箱" v-model="mail"></mt-field>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  export default {
    name: 'addMyContact',
    data () {
      return {
        name: '',
        mobile: '',
        mail: '',
        _selected: ''
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      valiateData: function () {
        if (  typeof(this.name) == "undefined" ||this.name.trim() == "") {
          Toast("请填写联系人姓名.");
          return false;
        }
        if (  typeof(this.mobile) == "undefined" ||this.mobile.trim() == "") {
          Toast("请填写联系人电话.");
          return false;
        }
        if (typeof(this.mobile) == "undefined" ||this.mobile.trim() != "") {
          var mobileReg = /^\d{11}$/;
          if (mobileReg.test(this.mobile.trim()) === false) {
            Toast("请输入正确的手机号.");
            return false;
          }
        }
        if (typeof(this.mail) == "undefined" ||this.mail.trim() != "") {
          var emailReg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
          if (emailReg.test(this.mail.trim()) === false) {
            Toast("请输入正确的邮箱号码.");
            return false;
          }
        }
        return true;
      },
      saveContact: function () {
        var flag = this.valiateData(); // 验证输入框
        if (!flag) {
          return;
        }
        var _addContacts_url = domain("_addContacts");
        var that = this;
        that.$http.post(
          _addContacts_url,
          {
            name: this.name,
            mail: this.mail,
            mobile: this.mobile
          },
          {emulateJSON: true}
          )
          .then(function (response) {
            //接口返回数据
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              history.go(-1); //后退1页
            } else {
              Toast(msg)
            }
          }, function (error) {
            Toast(error)
          }).catch(function (response) {
          //Toast("数据获取响应异常.");
        })
      },
      initParams: function () {
        let params = this.$route.query;
        this._selected = params._selected;
      }
    },
    components: {},
    mounted: function () {
      this.initParams();
    }
  }
</script>
<style>
  .savesigner .mint-cell-text {
    color: #7d7d7d;
  }
</style>



// WEBPACK FOOTER //
// src/module/my/AddMyContact.vue